import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationMediaDelete = {
    path: "/media",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationMediaDelete };
